import { render, staticRenderFns } from "./VerifiedEmail.vue?vue&type=template&id=fc7051a4&scoped=true"
import script from "./VerifiedEmail.vue?vue&type=script&lang=js"
export * from "./VerifiedEmail.vue?vue&type=script&lang=js"
import style0 from "./VerifiedEmail.vue?vue&type=style&index=0&id=fc7051a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc7051a4",
  null
  
)

export default component.exports